<template>
  <div>
    <el-row>
      <el-col>
        <el-select
          v-model="currentFilter"
          placeholder="Select any filter"
          size="small"
          filterable
          clearable
          @change="handleFilter"
        >
          <el-option
            v-for="(filter, index) in quickFiltersExternal"
            :key="index"
            :value="filter._id"
            :label="filter.filter_name"
          />
        </el-select>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  export default {
    props: {
      currentFilter: String,
      quickFiltersExternal: Array,
    },
    methods: {
      handleFilter(value) {
        this.$emit('filter-change', value);
      },
    },
  };
</script>
